import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ProtectedRoute from "./components/Navigation/ProtectedRoute";
import PublicRoute from "./components/Navigation/PublicRoute";
import EmployeeProfile from "./Pages/Profile"
import Documents from "./Pages/Employee/Documents";
import Login from "./Pages/Login";
import ForgotPassword from "./Pages/ForgotPassword";
import Reset from "./Pages/ResetPassword";
import UpdatePassword from "./Pages/UpdatePassword";
import NotFound from "./Pages/NotFound";
import PasswordExpired from "./Pages/Login/passwordExpired";
import EmployeeDashboard from "./Pages/Dashboard/EmployeeDashboard";
import ManageTimesheets from "./Pages/Employee/ManageTimesheets";
import TimeOff from "./Pages/Employee/TimeOff";
const App = () => {
  return (
      <Router>
        <Routes>
          <Route exact path="/" element={<ProtectedRoute />}>
            <Route exact path="/" element={<EmployeeDashboard />} />
            <Route path="/profile" element={<EmployeeProfile />} />
            <Route exact path="/documents" element={<Documents />} />
            <Route exact path="/updatePassword" element={<UpdatePassword/>}/>
            <Route exact path ="/passwordExpired" element={<PasswordExpired />}/>
            <Route exact path="/manage-timesheets" element={<ManageTimesheets />} />
            <Route exact path="/time-off" element={<TimeOff />} />
        </Route>
          <Route element={<PublicRoute />}>
            <Route path="/login" element={<Login />} />
            <Route path="/resetPassword" element={<ForgotPassword/>}/>
            <Route path="/resetpassword/:token" element={<Reset/>}/>
          </Route>
          <Route exact path="*" element={<NotFound/>} />
        </Routes>
      </Router>
  );
};

export default App;

